import {Elevation} from "@blueprintjs/core";
import {CardContainer, CardGrid, MinimalCard, StopListContainer} from "../../common/styles/cards.style";
import React, {useEffect} from "react";
import {ManifestCardHeaderV2, StopInfoItem} from "../../common/components/ManifestCardCommonV2";
import {createCardHandlers} from "../../common/utils/cardHandlers";
import {scrollToElement} from "../../common/utils/scrollToElement";
import {getStopListForMinimalCard} from "../../common/utils/getStopList";
import {ManifestCardPropsV2} from "../../common/types/cards.type";
import AssignmentLoadingWrapper from "../../common/components/AssignmentLoadingWrapper";

const ManifestDriverMinimumCard = React.memo(
  ({
    manifest,
    colors,
    isSelected,
    isHighlighted,
    disabled,
    isTimeFormat24hr,
    timezoneOfJobStop,
    cardConfigurations,
    onSelectedManifest,
    onDrillDownManifest,
    onLocationMarkerClick,
    isPending
  }: ManifestCardPropsV2) => {
    const {handleOnSelected, handleDrillDownManifest} = createCardHandlers({
      onSelectedManifest,
      onDrillDownManifest
    });

    const stopInfoStops = getStopListForMinimalCard(manifest);

    useEffect(() => {
      if (isSelected) {
        scrollToElement(`manifest-minimal-card-item-${manifest.manifestDriverId}`);
      }
    }, [isSelected, manifest.manifestDriverId]);

    return (
      <AssignmentLoadingWrapper isLoading={isPending}>
        <CardContainer
          id={`manifest-dnd-target-${manifest.manifestDriverId}`}
          data-manifestdriverid={manifest.manifestDriverId}
          data-cardtype={"min-card"}
        >
          <MinimalCard
            id={`manifest-minimal-card-item-${manifest.manifestDriverId}`}
            elevation={Elevation.ONE}
            isSelected={isSelected}
            isHighlighted={isHighlighted}
            disabled={disabled}
            data-testid={`manifest-minimal-card-item-${manifest.manifestDriverId}`}
            onClick={(e: any) => {
              if (!disabled) {
                handleOnSelected(e, manifest);
              }
            }}
          >
            <CardGrid data-testid={"card-grid"} isSelected={isSelected} bodyHeight={32}>
              <ManifestCardHeaderV2
                manifest={manifest}
                handleDrillDownManifest={handleDrillDownManifest}
                onLocationMarkerClick={onLocationMarkerClick}
                stopsColor={colors ?? []}
                isSelected={isSelected}
                disabled={disabled}
                cardConfigurations={cardConfigurations}
              />
              <StopListContainer className="minimal">
                {stopInfoStops?.map((x) => {
                  const color = (colors ?? []).find((y) => y.jobStopID === x.jobStopId)?.color ?? "";
                  return (
                    <StopInfoItem
                      key={`card-stop-info-${x.jobStopId}`}
                      stop={x}
                      color={color}
                      disabled={disabled ?? false}
                      isTimeFormat24hr={isTimeFormat24hr}
                      timezoneOfJobStop={timezoneOfJobStop}
                      cardConfigurations={cardConfigurations}
                    />
                  );
                })}
              </StopListContainer>
            </CardGrid>
          </MinimalCard>
        </CardContainer>
      </AssignmentLoadingWrapper>
    );
  }
);
ManifestDriverMinimumCard.displayName = "ManifestDriverMinimumCard";
export default ManifestDriverMinimumCard;
